import resultArrayToMbti from "../utils/resultArrayToMbti";
import { useEffect, useRef, useState } from "react";
import "../styles/App.scss";
import { Col, Row, Container, Button } from "react-bootstrap";
import { AnimatePresence, motion } from "framer-motion";

import resultPageData from "../data/resultPageData";
import useLongPress from "../hooks/useLongPress";
import { toPng } from 'html-to-image';

function ResultPage({ testResults, setCurrentPage, currentPage }) {

    const resultMbti = resultArrayToMbti(testResults);
    const componentRef = useRef();

    const onLongPress = () => {
        console.log(componentRef.current)
            if (componentRef.current === null) {
                return
            }

        toPng(componentRef.current, { cacheBust: true })
        .then((dataUrl) => {
            const link = document.createElement('a')
            link.download = 'my-image-name.png'
            link.href = dataUrl
            link.click()
        })
        .catch((err) => {
            console.log(err)
        })
        
    };


    return (
        
            <div className="flex-container" ref={componentRef}>
                <AnimatePresence mode="sync">
                <motion.div
                    key="background"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4 }}
            >
                <div className="background-image" style={{
                        backgroundImage: `url(${
                            resultPageData[resultMbti].backgroundImage
                        })`,
                    }}>
                <Container>
                    <Row className="justify-content-md-center title-row">
                            <Col>
                                <motion.h1
                                    key={resultMbti + "-title"}
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.4 }}
                                    style={{ color: resultPageData[resultMbti].textColor }}
                                >
                                    測驗結果：{resultPageData[resultMbti].name}
                                </motion.h1>
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center">
                            <Col>
                                <AnimatePresence mode="sync">
                                    <motion.img
                                        key={
                                            resultMbti + "-image"
                                        }
                                        src={
                                            `images/mbti-icons/${resultPageData[resultMbti]
                                                .image}`
                                        }
                                        alt="Result Image"
                                        initial={{ opacity: 1, y: -40 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -40 }}
                                        transition={{ duration: 0.8 }}
                                    />
                                </AnimatePresence>
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center">
                            <Col className="description" style={{ color: resultPageData[resultMbti].textColor }}>
                                {resultPageData[resultMbti].description}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button
                                    className="next-page-button-var1"
                                    variant="primary"
                                    size="lg"
                                    onClick={() => setCurrentPage((currentPage) => currentPage + 1)}
                                    type="button"
                                    style={{ zIndex: 10, position: "relative" }}
                                >
                                    <motion.span
                                        key={resultMbti + "-answer"}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        下一頁
                                    </motion.span>
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                    </div>
                </motion.div> 
                </AnimatePresence>
            </div>
    );
}

export default ResultPage;
